import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'

import {
	showHideModalAddFactura,
	showHideModalLastFactura
} from '../../actions/common'



class ModalLastFactura extends Component {
	handleCloseModal = (e) => {
		const modal = document.getElementById('modalLastFactura')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalLastFactura .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.showHideModalLastFactura(false), 300)
	}

	handleCloseParentModal = (e) => {
		const modalParent = document.getElementById('modalAddFactura')
		modalParent.classList.remove('fadeIn')
		modalParent.classList.add('fadeOut')

		const modal = document.getElementById('modalLastFactura')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		setTimeout(() => {
			this.props.showHideModalAddFactura(false)
			this.props.showHideModalLastFactura(false)
		}, 300)
	}

	render() {
		const { modalLastFactura, saldo, tolerancia} = this.props
		if (!modalLastFactura.get('show')) {
			return null
		}


		return(
			<Modal id="modalLastFactura" show={ true } ZIndex={ 2000 } >
				{(saldo <= 0 || Math.abs(saldo) <= Number(tolerancia))  ? (
					<Fragment>
					<ModalHeader title="Confirmación" onClose={ (e) => this.handleCloseModal(e) } />
					<ModalBody>
						<div style={{ width: '400px' }}>
							<div className="row">
								<div className="col-md-12" style={{ color: '#000', fontWeight: '300' }}>
									{ 'Está a punto de cerrar la solicitud. ¿Desea hacerlo?' }
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<button className="btn btn-default" type="button" onClick={ (e) => this.handleCloseParentModal(e) }>No</button>
						<button className="btn btn-default" type="button" onClick={ (e) => modalLastFactura.get('action')(true) }>Si</button>
					</ModalFooter>
					</Fragment>
				) : (
					<Fragment>
						<ModalHeader title="Confirmación" onClose={ (e) => this.handleCloseModal(e) } />
						<ModalBody>
							<div style={{ width: '400px' }}>
								<div className="row">
									<div className="col-md-12" style={{ color: '#000', fontWeight: '300' }}>
										{ 'Esta solicitud aún tiene saldo pendiente y no puede ser cerrado' }
									</div>
								</div>
							</div>
						</ModalBody>
						<ModalFooter>
							<button className="btn btn-default" type="button" onClick={ (e) => modalLastFactura.get('action')(false) }>Aceptar</button>
						</ModalFooter>
					</Fragment>
				)}

			</Modal>
		)
	}
}

const mapStateToProps = (state, onwProps) => {
	return {
		modalLastFactura: state.common.get('modalLastFactura'),
		modalAddFactura: state.common.get('modalAddFactura'),
		saldo:  (Number(state.common.getIn(['modalAddFactura', 'saldo'])) - Number(state.common.getIn(['modalAddFactura', 'data', 'valor_con_iva']))),
		tolerancia: state.common.getIn(['parametros', 'TOLERANCIA', 0, 'VALOR']) || 0
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		showHideModalLastFactura: (open) => dispatch(showHideModalLastFactura(open)),
		showHideModalAddFactura: (show) => dispatch(showHideModalAddFactura(show)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalLastFactura)



// WEBPACK FOOTER //
// ./src/components/Documentos/ModalLastFactura.jsx